const BREAKPOINT_TABLET = "md";
const BREAKPOINT_DESKTOP = "xl";
export {
  BREAKPOINT_DESKTOP,
  BREAKPOINT_TABLET
};
